import React from 'react';
import WebPage from 'pages/Dashboard/pages/Charts/pages/Details/components/ERx/WebPage';

export default function Notifications() {
  return (
    <div className="bg-primaryLight flex overflow-y-hidden h-full">
      <div className="flex-1 flex bg-white rounded-xl p-4 pb-0 overflow-y-auto">
        <div className="w-full h-full">
          <div className="relative h-[calc(100%+20px)] -m-5">
            <WebPage />
          </div>
        </div>
      </div>
    </div>

  );
}
